import type { RequestCopy } from "@/features/auth/components/auth-request-content";

/**
 * Copy for `/forgot`.
 *
 * Every string is verbatim from the live reference (xgodo.com/forgot, legacy
 * source `frontend/src/app/(Account)/forgot/page.tsx`). UX parity is strict:
 * this page says exactly these things and nothing else — no "remembered it?
 * back to sign in" line, no supporting caption.
 *
 * Note what the live page actually promises: it emails you a NEW PASSWORD, not
 * a reset link. The v5 page this replaces said "Enter your email and we'll send
 * you a reset link", which describes a flow the backend does not implement
 * (`POST /forgot` mails a generated password). The live wording is restored.
 *
 * ONE deliberate departure, the same one `/signup/resend_activation` makes: the
 * live generic-failure string reads "Somting went Wrong please try later!".
 * That is a typo, and the project already fixes legacy typos rather than
 * reproducing them (see `nav.ts`, where "Availabel Jobs" is corrected).
 *
 * The state machine, the `?scenario=` parser and the shared visual primitives
 * live in `auth-request-*` — `/forgot` and `/signup/resend_activation` are the
 * same page on the live site with different words.
 */
export const FORGOT_COPY: RequestCopy = {
  title: "Forgot Password",
  message:
    "Enter your email below and we will send you an email with new password.",
  placeholder: "Enter your email",
  submit: "Send Password",
  success: "Your new password has been sent to your email address!",
  notFound: "Sorry, we could not find your email address in our system!",
  failed: "Something went wrong, please try later!",
};
